import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import ContextualString from '../../../../../../../../components/contextual/ContextualString';
import flyerPrintTemplateStrings from './contextualStrings';
import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import getConfig from '../../../../../../../../util/config';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const FlyerPrintTemplateMatchesWG = ({ albumFolder, account }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  const url = `${getConfig().app.baseUrl}/galleries/o/album-folder/${
    albumFolder.id
  }`;

  const imageUrl = '/marketing-material/MARKETING_FLYER_PF_JOIN_CODE_2.png';

  return (
    <Fragment>
      <p className="marketing-material-flyer-main-copy">
        <strong>{account.organization_name}</strong>{' '}
        <ContextualString
          defaultMessage="is excited to announce we’re offering Waldo’s facial recognition powered mobile app to deliver photos to you! You’ll be able to sit back and relax while Waldo delivers YOUR photos to you and your family members!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={flyerPrintTemplateStrings}
        />
      </p>

      <p className="marketing-material-flyer-target-secondary-copy text-uppercase">
        {albumFolder.join_code}
      </p>
      <div
        className="marketing-material-flyer-qrcode-main pf-jc-flyer-qrcode"
        style={{
          top: '45%',
          right: '11%',
        }}
      >
        <QRCode renderAs="canvas" value={url} size={width * 0.27 ?? 500} />
      </div>

      <img ref={templateRef} src={getAsset(imageUrl)} alt="" />
    </Fragment>
  );
};

FlyerPrintTemplateMatchesWG.propTypes = propTypes;

export default FlyerPrintTemplateMatchesWG;
